import { render, staticRenderFns } from "./priceXin.vue?vue&type=template&id=a5d02f62&scoped=true&"
import script from "./priceXin.vue?vue&type=script&lang=js&"
export * from "./priceXin.vue?vue&type=script&lang=js&"
import style0 from "./priceXin.vue?vue&type=style&index=0&id=a5d02f62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d02f62",
  null
  
)

export default component.exports